import { createFeatureSelector } from '@ngrx/store';

import * as SiteStatusReducer from './site-status.reducer';

export const getAllSiteStatus = createFeatureSelector<SiteStatusReducer.SiteStatusState>(
  SiteStatusReducer.siteStatusFeatureKey
);
